import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InitialConfigModel, UpaUserProfileDataModel, Validation } from '../../../Core/models';
import { ValidationUiService, GenderValidationService, SwProcessStateService } from '../../../Core/Services';

@Component({
  selector: '[app-gender]',
  templateUrl: './gender.component.html',
  styleUrls: ['./gender.component.css']
})
export class GenderComponent implements OnInit {

  constructor(private genderValidationService: GenderValidationService, private swProcessStateService: SwProcessStateService) { }
  @Input() initialConfig: InitialConfigModel;
  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();
  public baseMakeImageUrl: string;
  public errorClass = '';
  public error: Validation = new Validation();
  public flag: number;

  @Input() isUpaEnable: boolean = false;
  @Input() isUserLoggedIn: boolean = false;
  @Input() upaUserData: UpaUserProfileDataModel;
  ngOnInit() {
    this.baseMakeImageUrl = this.initialConfig.urlConfig.baseImageUrl + "cj/";
    this.genderValidationService.genderValid$.subscribe({
      next: (error) => {
        this.error.isInValid = error.isInValid;
        this.error.errorCss = error.errorCss
      }
    })
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.swGender();
      } else if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        if (this.upaUserData.userGenderID) {
          this.flag = this.upaUserData.userGenderID == 1 ? 0 : 1;
        } else {
          this.flag = -1;
        }
      }
    })
  }

  ngOnChanges() {
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        if (this.upaUserData.userGenderID) {
          this.flag = this.upaUserData.userGenderID == 1 ? 0 : 1;
          this.submitAnswer(this.upaUserData.userGenderID == 1 ? 'Male' : 'Female');
        } else {
          this.flag = -1;
        }
      }
    })
  }

  swGender() {
    this.swProcessStateService.swProcessModel$.subscribe(swInput => {
        this.flag = swInput?.policyHolder[0]?.gender;
    })
  }
  submitAnswer(gender: string) {
    this.error = new Validation();
    this.onSubmit.emit(gender);
  }

}
